import React, { useEffect, useState, useRef } from "react";
import Card from "react-bootstrap/Card";
import { statiSondaggio } from "../../Utilities/statiElementEnum";
import Spinner from 'react-bootstrap/Spinner'; // Importa lo Spinner se vuoi usarlo
import './CountdownTimer.css'; // Assicurati di creare e importare questo file CSS


export default function CountdownTimer({ 
  dataChiusura, 
  dataInizio, 
  stato,
onTimeExpire }) {


  const [tempoRimanente, setTempoRimanente] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const [scaduto, setScaduto] = useState(false);
  const [notifiedExpired, setNotifiedExpired] = useState(false); // <-- Flag per notificare solo una volta

  // Questo ref ci dice se abbiamo già notificato la scadenza per
  // l'attuale set di parametri (stato, dataInizio, dataChiusura).
  const notifiedRef = useRef(false);
  //stato per indicare se ha finito di fare i calcoli per le ore mancanti
  const [isLoadingInitial, setIsLoadingInitial] = useState(true);

  // Ref per tenere traccia dell'intervallo attivo
  const intervalRef = useRef(null);


   // Effetto Principale
   useEffect(() => {
    let isMounted = true;
    // Pulisci intervallo precedente
    if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
    }

    console.log("CountdownTimer: Effetto eseguito/rieseguito.", { stato, dataInizio, dataChiusura });

    // --- GESTIONE STATO CONCLUSO ALL'INIZIO ---
    if (stato === statiSondaggio.Concluso) {
        console.log("CountdownTimer: Stato è Concluso all'inizio. Imposto stato finale e termino effetto.");
        setIsLoadingInitial(false);
        setScaduto(true);
        setTempoRimanente({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        // Non serve notificare o avviare timer
        return; // Esce dall'effetto immediatamente
    }

    // Se non è Concluso, procedi con la logica del timer
    setIsLoadingInitial(true);
    // 'scaduto' dovrebbe essere false se non siamo nello stato Concluso all'inizio
    setScaduto(false);
    // Resettiamo il tempo rimanente per mostrare il loading corretto
    setTempoRimanente({ days: 0, hours: 0, minutes: 0, seconds: 0 });

    // Flag per notificare solo una volta *per questa esecuzione dell'effetto*
    let notifiedThisRun = false;

    const calculateTime = () => {
      if (!isMounted) return;

      const dateInizioTime = dataInizio ? new Date(dataInizio).getTime() : NaN;
      const dateChiusuraTime = dataChiusura ? new Date(dataChiusura).getTime() : NaN;

      const targetDate =
        stato === statiSondaggio.Pubblicato
          ? dateInizioTime
          : dateChiusuraTime; // Sarà InCorso qui

      if (isNaN(targetDate)) {
        console.error("Data non valida:", stato === statiSondaggio.Pubblicato ? dataInizio : dataChiusura);
        if (isMounted) {
          setScaduto(true);
          setIsLoadingInitial(false);
          setTempoRimanente({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        }
        // Ferma intervallo se attivo
        if (intervalRef.current) clearInterval(intervalRef.current);
        return;
      }

      const now = new Date().getTime();
      const diff = targetDate - now;

      if (diff <= 0) { // --- CASO SCADUTO ---
        if (isMounted) {
          // Notifica solo se non già fatto IN QUESTA ESECUZIONE dell'effetto
          if (!notifiedThisRun) {
            console.log(`CountdownTimer: diff <= 0 (${diff}). Chiamo onTimerExpire.`);
            onTimeExpire?.();
            notifiedThisRun = true; // Segna come notificato per questa run
          }
          // Aggiorna stato interno
          setScaduto(true);
          setTempoRimanente({ days: 0, hours: 0, minutes: 0, seconds: 0 });
          setIsLoadingInitial(false);
        }
        // Ferma l'intervallo
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
        return; // Esce
      } else { // --- CASO NON SCADUTO (diff > 0) ---
         if (isMounted) {
            // Calcola e aggiorna tempo rimanente
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);
            setTempoRimanente({ days, hours, minutes, seconds });
            setScaduto(false); // Non è scaduto
            setIsLoadingInitial(false); // Finito loading

            // Avvia l'intervallo SE non è già attivo
            if (!intervalRef.current) {
                console.log("CountdownTimer: Avvio setInterval (da diff > 0).");
                intervalRef.current = setInterval(calculateTime, 1000);
            }
         }
      }
    }; // Fine calculateTime

    // Primo calcolo
    calculateTime();

    // Cleanup
    return () => {
      console.log("CountdownTimer: Cleanup effect.");
      isMounted = false;
      if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
      }
    };
  }, [stato, dataInizio, dataChiusura, onTimeExpire]); // Dipendenze corrette
  // Imposta colore bordo e titolo
  let bordo = "secondary";
  let titolo = "Sondaggio";

  // Considera lo stato isLoadingInitial per il titolo se vuoi
  if (isLoadingInitial) {
     titolo = "Caricamento...";
   } else if (stato === statiSondaggio.InCorso) {
    bordo = "primary";
    titolo = "Tempo rimanente per completare il sondaggio";
  } else if (stato === statiSondaggio.Pubblicato) {
    bordo = "warning";
    titolo = "Il sondaggio si aprirà tra:";
  } else if (scaduto || stato === statiSondaggio.Concluso) {
    bordo = "success";
    titolo = "Il sondaggio è terminato!";
  }

  return (
    <div className="position-relative mt-4">
      {/* Titolo con background che imita il bordo della card */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "2.5rem",
          backgroundColor: getColorFromBorder(bordo),
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 600,
          fontSize: "0.95rem",
          borderTopLeftRadius: "0.375rem",
          borderTopRightRadius: "0.375rem",
          zIndex: 1,
        }}
      >
        {titolo}
      </div>

      <Card
        className={`cartaSommarioBorder mt-3`}
        border={bordo}
        style={{ paddingTop: "2.5rem" }} // spazio per il titolo
      >
        <Card.Body className="bg-white d-flex flex-column align-items-center justify-content-center py-4">
        <div className="d-flex justify-content-around w-100 timer-circles-container">
          <TimeCircle label="GIORNI" value={tempoRimanente.days} isLoading={isLoadingInitial} />
            <TimeCircle label="ORE" value={tempoRimanente.hours} isLoading={isLoadingInitial} />
            <TimeCircle label="MINUTI" value={tempoRimanente.minutes} isLoading={isLoadingInitial} />
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}

function getColorFromBorder(bordo) {
  const colori = {
    primary: "#0369a1",     // colore di bootstrap primary
    warning: "#f0ad4e",     // bootstrap warning
    success: "#5cb85c",      // bootstrap success
    secondary: "#38bdf8",  // bootstrap secondary
  };
  return colori[bordo] || "black"; // fallback
}



function TimeCircle({ label, value, isLoading }) {
  return (
    <div className="text-center mx-2 time-circle-wrapper">
      <div
      // Classe per lo stile del loader
      className={`time-circle-inner ${isLoading ? 'loading' : ''}`}
        style={{
          width: "60px",
          height: "60px",
          borderRadius: "50%",
          border: "2px dotted #000000",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "1.2rem",
          position: 'relative',
        }}
      >
        {/* Mostra il valore solo se non sta caricando */}
        {!isLoading ? (
          value.toString().padStart(2, "0")
        ) : (
          null
        )}
      </div>
      <div style={{ fontSize: "0.75rem", marginTop: "0.5rem", color: '#6c757d' }}>{label}</div>
    </div>
  );
}
